// extracted by mini-css-extract-plugin
module.exports = {"result":"ErrorPage_result__3qj4X","image":"ErrorPage_image__kMImW"};